import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {HolidayCard} from '../../interfaces/holiday-card';
import {Observable, Subscription} from 'rxjs';
import {HolidaySearchFilterService} from '../../services/holiday-search-filter.service';
import {Pagination} from '../../../../../shared/interfaces/pagination';
import {ResultOrderTypes} from '../../../../../shared/models/result-order-types.enum';

@Component({
  selector: 'app-holiday-search-list',
  templateUrl: './holiday-search-list.component.html',
  styleUrls: ['./holiday-search-list.component.scss']
})
export class HolidaySearchListComponent implements OnInit, OnDestroy {

  @Input() filteredHolidaysList$: Observable<HolidayCard[]>;
  @Input() selectedOrderType: ResultOrderTypes;
  @Input() ages: number[];

  trigger: number;
  triggerSubscription: Subscription;
  pagination: Pagination;

  constructor(private _holidaySearchFilterService: HolidaySearchFilterService) { }

  ngOnInit(): void {
    this.pagination = this._holidaySearchFilterService.pagination;
    this.triggerSubscription = this._holidaySearchFilterService.updateTrigger.subscribe(e => {
      this.trigger = e;
    });
  }

  ngOnDestroy(): void {
    this.triggerSubscription?.unsubscribe();
  }
}
